module.exports = __webpack_public_path__ + "img/icon_sportMenu_pcgame.4b116c1c.svg";